import {notify} from './utils.js';
import router from '../../router.js';

async function try_catch(func) {
    try {
        return await func();
    } catch (e) {
        if (!e) {
            console.debug('Dialog cancel');
            return;
        }
        if (e?.constructor?.name === 'AxiosError') {
            switch (e.status) {
            case 401:
                // console.debug(e);
                notify('warning', `未登录！`);
                router.push('/login');
                break;
            case 403:
                // console.debug(e);
                notify('warning', `权限不足！`);
                router.push('/');
                break;
            default:
                console.error(e);
                notify('error', e.code, e.message);
            }
        } else {
            if (e === 'cancel') {
                console.info('取消');
                notify('warning', '取消');
            } else {
                console.error(e, e.message);
                notify('error', e);
            }
        }
    }
}

export {
    try_catch,
};
